import type { NodeV2 } from '@vedalib/editor'
import type { EditorElement } from '@vedalib/editor/lib/elements'
import React, { useState } from 'react'

import { useAvailableElements } from 'components/Editor/NodeV2/Picker/useAvailableElements'
import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import Search from 'components/uiKit/Search'
import { Typography } from 'components/uiKit/Typography'
import type { Block, MapType } from 'services/Store/Project/types'

import TileElement from '../TileElement'
import * as s from './TabElements.module.scss'

interface ITabElementsProps {
  block: Block
  parent: NodeV2
  onAdd: (
    node: NodeV2,
    data?: { nodes?: MapType<NodeV2>; elements?: MapType<EditorElement> },
  ) => void
}

const TabElements: React.FC<ITabElementsProps> = ({ onAdd, parent, block }) => {
  const [search, setSearch] = useState<string>()
  const available = useAvailableElements(block, search)

  return (
    <div className={s.root}>
      <Padding bottom sides top>
        <Search name='elements' onChange={setSearch} value={search} width='100%' />
      </Padding>
      <LayoutScroll sizeAutoCapable>
        <Padding bottom gap sides>
          {available.map((group) => (
            <div className={s.group} key={group.name}>
              <Typography styleType='hint'>{group.name}</Typography>
              <div className={s.items}>
                {group.items.map((item) => (
                  <TileElement
                    block={block}
                    item={item}
                    key={item.type}
                    onAdd={onAdd}
                    parent={parent}
                  />
                ))}
              </div>
            </div>
          ))}
        </Padding>
      </LayoutScroll>
    </div>
  )
}

export default TabElements
